<div class="default-dialog-wrapper mat-elevation-z10">
    <div class="flex flex-row content">
      <div class="flex flex-col justify-between w-100-percent">
        <div class="flex flex-row w-100-percent">
          <h1 class="flex flex-wrap basis-full mat-headline-5 mb-14 fw-600 mr-98">{{title | titlecase}}</h1>
          <mat-icon svgIcon="close" class="flex justify-end cursor-pointer icon-lg" [matDialogClose]="false"></mat-icon>
        </div>
        <mat-divider class="w-100-percent mb-16 divider-color"></mat-divider>
        <div class="additional-components-height">
            <div class="mat-subtitle-2 fw-600 fs-20 mb-16">{{'CREATE_SERVICE.ADDITIONAL_CAPABILITIES' | transloco}}</div>
            <div *ngFor="let capability of component.nestedObj">
                <div class="flex flex-row w-100-percent mb-16" [ngClass]="{'disabled': capability?.disabled}" (click)="selectCapability(capability)">
                    <mat-icon [svgIcon]="capability?.selected ? 'check_box' : 'check_box_outline_blank'" class="icon-md-1 mr-12 cursor-pointer"></mat-icon>
                    <span class="fw-400 fs-16">{{ capability?.displayName ? (capability?.displayName) : (capability?.name) }}</span>
                </div>
            </div>
        </div>
        <mat-divider class="w-100-percent mb-32 divider-color"></mat-divider>
        <div class="flex flex-row justify-end w-100-percent">
          <button class="white mr-12" [matDialogClose]="false">{{'DIALOG.CANCEL'| transloco}}</button>
          <button class="accent" [ngClass]="{'disabled': !selection}" [disabled]="!selection" (click)="apply()" >{{confirmButtonText}}</button>
        </div>
      </div>
    </div>
  </div>